import { createSelector } from "reselect";
import { ListFieldsKeys } from "src/api/config";
import { Status } from "src/modules/modules.type";
import { RootState } from "src/store/rootReducer";

const getStatus = (state: RootState, listName: ListFieldsKeys): Status => {
  return state.spitems.getStatus[listName] || "IDLE";
};

const addStatus = (state: RootState, listName: ListFieldsKeys): Status => {
  return state.spitems.addStatus[listName] || "IDLE";
};

const updateStatus = (state: RootState, listName: ListFieldsKeys): Status => {
  return state.spitems.updateStatus[listName] || "IDLE";
};

const deleteStatus = (state: RootState, listName: ListFieldsKeys): Status => {
  return state.spitems.deleteStatus[listName] || "IDLE";
};

const getItemStatus = (state: RootState, listName: ListFieldsKeys): Status => {
  return state.spitems.getItemStatus[listName] || "IDLE";
};

export const selectGetStatus = createSelector([getStatus], (status) => {
  if (!status) return "IDLE";
  return status;
});

export const selectAddStatus = createSelector([addStatus], (status) => {
  if (!status) return "IDLE";
  return status;
});

export const selectUpdateStatus = createSelector([updateStatus], (status) => {
  if (!status) return "IDLE";
  return status;
});

export const selectDeleteStatus = createSelector([deleteStatus], (status) => {
  if (!status) return "IDLE";
  return status;
});
export const selectGetItemStatus = createSelector([getItemStatus], (status) => {
  if (!status) return "IDLE";
  return status;
});
